<template>
    <div class="flex flex-wrap -mx-6">
        <div v-for="event in events" :key="event.id" class="flex flex-col flex-shrink w-full p-6 pt-0 sm:w-1/2 md:w-1/3">
            <router-link :to="{ name: 'Event', params: {id: event.id}}">
                <div class="flex-1 overflow-hidden bg-white rounded shadow-lg">
                    <div class="relative">
                        <img :src=event.artistimage class="object-cover w-full h-auto">
                        <div class="absolute top-0 left-0 w-full h-full border-4 border-live-orange hover:border-live-blue" style="box-shadow: inset 0px -200px 75px -90px rgba(0,0,0,0.75)"></div>

                        <div class="absolute bottom-0 flex flex-col items-start justify-between w-full pointer-events-none">
                            <p class="px-6 text-xl font-bold text-white md:text-lg">{{ event.artist }}</p>
                            <div>
                                <p class="px-6 text-xs text-white md:text-sm">{{ event.date }}</p>
                                <p class="px-6 pb-6 text-xs text-white md:text-sm">{{ event.date }} Uhr</p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    import firebase from "firebase/app";
    import "firebase/auth";
    import "firebase/functions";

    export default {
        data() {
            return {
                events: [],
            }
        },
        methods: {
            upvoteThisEvent(id) {
            //console.log(id);
            const upvoteEvent = firebase.functions().httpsCallable('upvoteEvent');
            upvoteEvent({ id })
            .catch(error => {
                console.log(error.message);
            });
            }
        },
        mounted() {
            const ref = firebase.firestore().collection('events').orderBy('date', 'desc');
            ref.onSnapshot(snapshot => {
            let events = [];
            snapshot.forEach(doc => {
                events.push({...doc.data(), id: doc.id});
            });
            this.events = events;
            });
        }
    }
</script>

<style lang="scss" scoped>

</style>